import { gql } from '@apollo/client';

export default gql`
query vehicleOptions($modelId: Int!) {
  vehicleOptions(modelId: $modelId) {
    id
    price
    currency
    active
    isHidden
    vehicleOptionType {
      id
      categoryCode
      categoryName
      typeCode
      typeName
    }
    combinations {
      vehicleOptionId
      vehicleOptionTypeId
      vehicleOptionTypeCategoryCode
    }
    createdBy
  }
}
`;
